'use strict';

angular.module('docketbook').
	service('alertService', function (accessControl, $rootScope, $http, $stateParams, $q, Restangular, $timeout) {

		var predefinedAlerts = {
			'saveOrder': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save your order. Please try again.",
					title: 'Oops'
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this order. Contact your organisation admin.",
					title: 'Access Denied'
				},
				400: {
					type: 'error',
					message: "Something was wrong with the order when we tried to save it. Check all required fields have been supplied.",
					title: "Invalid Order"
				}
			},
			'sendOrder': {
				500: {
					type: 'error',
					message: 'Something went wrong when we tried to update your order. Please try again.',
					title: 'Oops'
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to send this order. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the order when we tried to send it. Check all required fields have been supplied.",
					title: "Invalid Order"
				}
			},
			'acceptOrder': {
				500: {
					type: 'error',
					message: 'Something went wrong when we tried to update your order. Please try again.',
					title: 'Oops'
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to accept this order. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the order when we tried to accept it. Check all required fields have been supplied.",
					title: "Invalid Order"
				}
			},
			'rejectOrder': {
				500: {
					type: 'error',
					message: 'Something went wrong when we tried to update your order. Please try again.',
					title: 'Oops'
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to reject this order. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the order when we tried to reject it. Check all required fields have been supplied.",
					title: "Invalid Order"
				}
			},
			'closeOrder': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to update your order. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to close this order. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the order when we tried to close it. Check all required fields have been supplied.",
					title: "Invalid Order"
				}
			},
			'deleteOrder': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to delete your order. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to delete this order. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the order when we tried to delete it. Check all required fields have been supplied.",
					title: "Invalid Order"
				}
			},
			'sendBulkOrders': {
				200: {
					type: 'success',
					message: 'Orders successfully sent.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the orders selected could not be sent. Check that they are in valid and try again.',
					title: 'Hold Tight!'
				}
			},
			'acceptBulkOrders': {
				200: {
					type: 'success',
					message: 'Orders successfully accepted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the orders selected could not be accepted. Check that they are in the sent status and try again.',
					title: 'Hold Tight!'
				}
			},
			'rejectBulkOrders': {
				200: {
					type: 'success',
					message: 'Orders successfully rejected.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the orders selected could not be rejected. Check that they are in the sent status and try again.',
					title: 'Hold Tight!'
				}
			},
			'closeBulkOrders': {
				200: {
					type: 'success',
					message: 'Orders successfully closed.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the orders selected could not be closed. Check if they can be closed and try again.',
					title: 'Hold Tight!'
				}
			},
			'deleteBulkOrders': {
				200: {
					type: 'success',
					message: 'Orders successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the orders selected could not be deleted.',
					title: 'Hold Tight!'
				}
			},
			'jobStatusChange': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to update your status. Please try again.",
					title: 'Oops'
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to do this. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'saveJob': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save your job. Please try again.",
					title: 'Oops'
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this job. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the job when we tried to save it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'deleteJob': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to delete your job. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to delete this job. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'sendJob': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to send your job. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to send this job. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the job when we tried to send it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'rejectJobWithDockets': {
				400: {
					type: 'warning',
					message: "You cannot reject this job because you have already created Dockets for it.",
					title: "Warning"
				}
			},
			'closeJob': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to close your job. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to close this job. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the job when we tried to close it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'addJobComment': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save your comment. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to comment on this job. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'removeJobComment': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to remove this comment. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to remove this comment. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'deleteBulkJobs': {
				200: {
					type: 'success',
					message: 'Jobs successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the jobs selected could not be deleted. Check that they can be deleted and try again.',
					title: 'Hold Tight!'
				}
			},
			'sendBulkJobs': {
				200: {
					type: 'success',
					message: 'Jobs successfully sent.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the jobs selected could not be sent. Check that they can be sent and try again.',
					title: 'Hold Tight!'
				}
			},
			'closeBulkJobs': {
				200: {
					type: 'success',
					message: 'Jobs successfully closed.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the jobs selected could not be closed. Check that they can be closed and try again.',
					title: 'Hold Tight!'
				}
			},
			'saveDocket': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this docket. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this docket. Contact your organisation admin.",
					title: "Access Denied"
				},
				551: {
					type: 'error',
					message: "Something went wrong when we tried to save the signatures for this docket. Please try again.",
					title: "Oops"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the docket when we tried to save it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'deleteDocket': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to delete this docket. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to delete this docket. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'sendDocket': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to send this docket. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to send this docket. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the docket when we tried to send it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'acceptDocket': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to accept this docket. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to accept this docket. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the docket when we tried to accept it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'rejectDocket': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to reject this docket. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to reject this docket. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the docket when we tried to reject it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'deleteBulkDockets': {
				200: {
					type: 'success',
					message: 'Dockets successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the dockets selected could not be deleted.',
					title: 'Hold Tight!'
				}
			},
			'sendBulkDockets': {
				200: {
					type: 'success',
					message: 'Dockets successfully sent.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the dockets selected could not be sent. Remember, dockets have to be valid before they can be sent.',
					title: 'Hold Tight!'
				}
			},
			'rejectBulkDockets': {
				200: {
					type: 'success',
					message: 'Dockets successfully rejected.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the dockets selected could not be rejected.',
					title: 'Hold Tight!'
				}
			},
			'acceptBulkDockets': {
				200: {
					type: 'success',
					message: 'Dockets successfully accepted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the dockets selected could not be accepted.',
					title: 'Hold Tight!'
				}
			},
			'acceptFileBulkDocketsAccepted': {
				200: {
					type: 'success',
					message: 'Dockets successfully accepted and filed.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the dockets selected could not be accepted. Please check failed dockets and try filing again.',
					title: 'Hold Tight!'
				}
			},
			'uploadDocketAttachment': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save your attachment. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to upload attachments for this docket. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'fileDocket': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to file this docket. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to file this docket. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'openDocketFiling': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to open this docket to file. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to open this docket. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'saveDocketFiling': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to file this docket. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to file this docket. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'deleteBatch': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to delete this batch. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to delete this batch. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'deleteBulkBatches': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to delete these batches. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to delete these batches. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'saveContact': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this contact. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this contact. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the contact when we tried to save it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'deleteContact': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to delete this contact. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to delete this contact. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'importContacts': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to import these contacts. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to import these contacts. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'contactShare': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to send this contact share. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to send a contact share. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'getOrgGroup': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to load this organisation unit. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to load this organisation unit. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'saveOrgGroupSample': {
				400: {
					type: 'error',
					message: "Unfortunately, the sample company has a limit of 4 user-creatable organisation groups.",
					title: "Oops"
				}
			},
			'saveOrgGroupExceed': {
				400: {
					type: 'error',
					message: "Creating this organisation group would exceed your current plan limits.",
					title: "Oops"
				}
			},
			'saveOrgGroupDisallowed': {
				400: {
					type: 'error',
					message: "Unfortunately, your plan does now allow for the creation of additional organisation groups.",
					title: "Oops"
				}
			},
			'saveOrgGroup': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this organisation unit. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this organisation unit. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the group when we tried to save it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'addGroupMembers': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to add these members to the unit. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to add members to this unit. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'removeGroupMember': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to remove this member from the unit. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to remove this member from the unit. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'removeGroupOwner': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to remove this owner from the unit. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to remove this owner from the unit. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'removeGroupMonitor': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to remove this monitor from the unit. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to remove this monitor from the unit. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'addGroupMember': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to add member(s) to the unit. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to add member(s) to the unit. Contact your organisation admin.",
					title: "Access Denied"
				},
				401: {
					type: 'error',
					message: "It looks like a user with the selected role already exists in this unit.",
					title: "Hold Up!"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'addGroupOwner': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to add owner(s) to the unit. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to add owner(s) to the unit. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'addGroupMonitor': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to add monitor(s) to the unit. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to add monitor(s) to the unit. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'saveRole': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this role. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this role. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'deleteBulkRoles': {
				200: {
					type: 'success',
					message: 'Roles successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the roles selected could not be deleted.',
					title: 'Hold Tight!'
				}
			},
			'getTemplate': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to load this template. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to load this template. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'saveTemplate': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this template. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this template. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				},
				999: {
					type: 'error',
					message: "A template can not be un-published once it is published",
					title: "Published Template"
				}
			},
			'deleteTemplate': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to delete this template. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to delete this template. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'deleteBulkTemplates': {
				200: {
					type: 'success',
					message: 'Templates successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the templates selected could not be deleted.',
					title: 'Hold Tight!'
				},
				500: {
					type: 'error',
					message: "Something went wrong when we tried to delete these templates. Please try again.",
					title: "Oops"
				}
			},
			'saveField': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this field. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this field. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'deleteBulkFields': {
				200: {
					type: 'success',
					message: 'Fields successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the fields selected could not be deleted.',
					title: 'Hold Tight!'
				}
			},
			'saveChecklistTemplate': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this checklist. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this checklist. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'deleteBulkChecklists': {
				200: {
					type: 'success',
					message: 'Checklists successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the checklist selected could not be deleted.',
					title: 'Hold Tight!'
				}
			},
			'saveFileCode': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this file code. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this file code. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the file code when we tried to save it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'deleteBulkFileCodes': {
				200: {
					type: 'success',
					message: 'File codes successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the file codes selected could not be deleted.',
					title: 'Hold Tight!'
				}
			},
			'readFile': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to read this file. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to read this file. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'importFileCodes': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to import file codes. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to import file codes. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'createSampleCompany': {
				400: {
					type: 'error',
					message: "It seems you already have a Sample Company setup. Each user is only allowed a single sample company.",
					title: "Oops"
				}
			},
			'saveResource': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this resource. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this resource. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the resource when we tried to save it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'importResources': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save these resources. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save these resources. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			},
			'deleteBulkResources': {
				200: {
					type: 'success',
					message: 'Resources successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the resources selected could not be deleted.',
					title: 'Hold Tight!'
				}
			},
			'saveResourceCategory': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this resource category. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this resource category. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the category when we tried to save it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'deleteBulkResourceCategories': {
				200: {
					type: 'success',
					message: 'Resource categories successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the resource categories selected could not be deleted.',
					title: 'Hold Tight!'
				}
			},
			'saveUom': {
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this unit of measure. Please try again.",
					title: "Oops"
				},
				403: {
					type: 'error',
					message: "It looks like you don't have permission to save this unit of measure. Contact your organisation admin.",
					title: "Access Denied"
				},
				400: {
					type: 'error',
					message: "Something was wrong with the unit of measure when we tried to save it. Please check required fields have been supplied.",
					title: "Oops"
				}
			},
			'deleteBulkUoms': {
				200: {
					type: 'success',
					message: 'Uoms successfully deleted.',
					title: 'Success!'
				},
				202: {
					type: 'warning',
					message: 'It looks like some of the uoms selected could not be deleted.',
					title: 'Hold Tight!'
				}
			},
			'uploadOrgLogo': {
				200: {
					type: 'success',
					message: 'Logo updated.',
					title: "Success!"
				},
				500: {
					type: 'error',
					message: "Something went wrong when we tried to save this logo. Please try again.",
					title: "Oops"
				},
				400: {
					type: 'error',
					message: "An unknown error occured.",
					title: "Oops"
				}
			}
		};

		var predefinedValidationAlerts = {
			'sendOrder': {
				message: 'Some fields are required before you can send this order.'
			},
			'acceptOrder': {
				message: 'Some fields are required before you can accept this order.'
			},
			'orderCreateJob': {
				message: 'Some fields are required before you can create a job for this order.'
			},
			'orderCreateDocket': {
				message: 'Some fields are required before you can create a docket for this order.'
			},
			'sendJob': {
				message: "Some fields are required before you can send this job."
			},
			'jobCreateDocket': {
				message: "Some fields are required before you can create a docket for this job."
			},
			'sendDocket': {
				message: "Some fields are required before you can send this docket."
			}
		};

		var presentValidationAlert = function (message, exceptions) {
			$("#alert").hide();
			var fields = [];
			for (var i = 0; i < exceptions.length; i++) {
				var field = exceptions[i].replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
				var words = field.split(" ");
				var fieldFancy = "";
				for (var j = 0; j < words.length; j++) {
					fieldFancy += words[j].substring(0, 1).toUpperCase();
					fieldFancy += words[j].substring(1);
					fieldFancy += " ";
				}
				fields.push(fieldFancy);
			}
			$rootScope.alert = { type: 'warning', title: 'Hold Tight!', message: message, fields: fields };
			$rootScope.closeAlert = function () {
				$("#alert").fadeOut(200);
			}
			$("#alert").fadeIn(200).css('display', 'table');
		}

		this.presentValidationAlert = presentValidationAlert;

		this.presentAutoValidationAlert = function (alertName, exceptions) {
			var alert = predefinedValidationAlerts[alertName];
			presentValidationAlert(alert.message, exceptions);
		}

		var presentAlert = function (type, title, message, supportError) {
			$("#alert").hide();
			var showSupport = false;
			if (supportError && supportError.status != 200) {
				showSupport = true;
			}
			$rootScope.alert = { type: type, title: title, message: message, supportError: supportError, showSupportButton: showSupport };
			$rootScope.closeAlert = function () {
				$("#alert").fadeOut(200);
			}
			$("#alert").fadeIn(200).css('display', 'table');
		}

		this.presentAlert = presentAlert;

		this.presentConfirmAlert = function (title, message, buttonActions, cb) {
			$("#alert").hide();
			$rootScope.alert = { type: 'warning', title: title, message: message, alertButtons: buttonActions };
			$rootScope.alertButtonPress = function (action) {
				$("#alert").fadeOut(200);
				cb(action);
			}
			$("#alert").fadeIn(200).css('display', 'table');
		}

		this.presentAutoAlert = function (alertName, errorObject) {
			var alert = predefinedAlerts[alertName][errorObject.status];
			if (alert) {
				presentAlert(alert.type, alert.title, alert.message, errorObject);
			}
		}

		this.contactSupportError = function (err) {
			var requestId = "unknown";
			if (err && err.headers) {
				requestId = err.headers('x-request-id');
			}
			if (err && err.status == 202 && err.requestName) {
				requestId = err.requestName;
			}
			Intercom('showNewMessage', 'Hi, I got an error with the request id: ' + requestId + ' (W) and Status Code: ' + err.status);
		}
	});



// WEBPACK FOOTER //
// ./src/services/alertService.js